
(function(){
  if (window.VariantHub && typeof window.VariantHub.on==='function') return; // 已存在就不重复

  function normId(v){ if(v==null) return ""; var s=String(v); var m=s.match(/(\d+)/g); return m? m[m.length-1] : ""; }

  function getVariantFromDOM(){
    // 1) URL 参数
    try{ var u=new URL(location.href); var q=u.searchParams.get('variant'); if(q) return { id:normId(q) }; }catch(_){}
    // 2) 表单隐藏 input
    var input=document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return { id:normId(input.value) };
    // 3) Shopify 全局
    try{ var a=window.ShopifyAnalytics?.meta?.selectedVariantId; if(a) return { id:normId(a) }; }catch(_){}
    try{ var m=window.meta?.product?.selected_or_first_available_variant?.id; if(m) return { id:normId(m) }; }catch(_){}
    return null;
  }

  var listeners = new Set();
  var lastId = null;

  function emitNow(vObj){
    var id = vObj && vObj.id ? normId(vObj.id) : "";
    if (!id || id === lastId) return;
    lastId = id;
    requestAnimationFrame(function(){
      listeners.forEach(function(fn){ try{ fn({ id:id }); }catch(_){ } });
    });
  }
  function schedule(){ setTimeout(function(){ var v=getVariantFromDOM(); if(v) emitNow(v); }, 20); }

  // 公共 API
  window.VariantHub = {
    on: function(fn){ listeners.add(fn); try{ var v=getVariantFromDOM(); if(v) fn(v); }catch(_){ } return function(){ listeners.delete(fn); }; },
    current: function(){ return getVariantFromDOM(); }
  };

  // 主题自带 pub/sub（若存在）
  try{
    if (typeof window.subscribe==='function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange){
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function(evt){
        var v = (evt && (evt.data?.variant || evt.detail?.variant || evt.variant)) || getVariantFromDOM();
        emitNow(v);
      });
    }
  }catch(_){}

  // 全局事件委托：不怕节点被替换
  document.addEventListener('change', function(e){
    var t=e.target;
    if (!t) return;
    if (t.name==='id' || t.name==='options' || t.type==='radio' || t.tagName==='SELECT'){ schedule(); }
  }, true);
  document.addEventListener('input', function(e){
    var t=e.target; if (t && t.name==='id') schedule();
  }, true);

  // 监听整个 body：新表单/新 input 插入、以及 input[name=id] 的 value 改变
  var mo = new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      var m = muts[i];
      if (m.type==='attributes'){
        var el = m.target;
        if (el && m.attributeName==='value' && el.getAttribute && el.getAttribute('name')==='id'){ schedule(); }
      } else if (m.type==='childList'){
        if (m.addedNodes && m.addedNodes.length){
          for (var j=0;j<m.addedNodes.length;j++){
            var n = m.addedNodes[j];
            if (n.nodeType===1){
              if (n.matches && (n.matches('form[action*="/cart/add"]') || n.matches('[name="id"]'))) { schedule(); break; }
              if (n.querySelector && (n.querySelector('form[action*="/cart/add"]') || n.querySelector('[name="id"]'))) { schedule(); break; }
            }
          }
        }
      }
    }
  });
  mo.observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['value']});

  // URL 变化
  (function(history){
    ['pushState','replaceState'].forEach(function(k){
      var orig=history[k]; if(!orig) return;
      history[k]=function(){ var ret=orig.apply(this, arguments); window.dispatchEvent(new Event('variantHub:urlchange')); return ret; };
    });
  })(window.history);
  window.addEventListener('variantHub:urlchange', schedule);
  window.addEventListener('popstate', schedule);
  window.addEventListener('locationchange', schedule);

  // 常见自定义事件兜底
  ['variant:changed','variant:change','product:variant-change'].forEach(function(ev){
    document.addEventListener(ev, function(e){
      var v = (e && (e.detail?.variant || e.variant)) || getVariantFromDOM();
      emitNow(v);
    }, true);
  });

  // 最终保险
  setInterval(schedule, 1200);
})();
